import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const SignupOrLoginMethodFields = {
  group: ELEMENT_GROUPS.AUTH,
  label: 'Signup/Login Method',
  icon: 'UserAddIcon',
  description:
    'Adds a set of buttons to allow the user to choose how they want to signup or login',
  properties: [
    {
      label: 'Authentication Action',
      name: 'authenticationAction',
      editor: 'dropdown',
      default: 'login',
      description: '',
      options: [
        {
          label: 'Show Login Methods',
          value: 'login'
        },
        {
          label: 'Show Signup Methods',
          value: 'signup'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    'alignment',
    'margin',
    'padding',
    {
      label: 'Enable Email',
      name: 'enableEmail',
      editor: 'boolean',
      default: true,
      description: 'Show the login/signup by Email Button',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Email Screen',
      name: 'emailScreen',
      description:
        'The destination screen to go to when the email button is clicked',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [{ field: 'enableEmail', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Enable Phone',
      name: 'enablePhone',
      editor: 'boolean',
      default: true,
      description: 'Show the login/signup by Phone',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Phone Screen',
      name: 'phoneScreen',
      description:
        'The destination screen to go to when the phone button is clicked',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [{ field: 'enablePhone', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Enable Facebook',
      name: 'enableFacebook',
      editor: 'boolean',
      default: true,
      description: 'Show the login/signup by Facebook button',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Facebook Post-Action Screen (existing user)',
      name: 'facebookScreenExistingUser',
      description:
        'The destination screen to go to after Facebook Login or Signup (if the user already had a user record in firestore)',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [{ field: 'enableApple', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Facebook Post-Action Screen (new user)',
      name: 'facebookScreenNewUser',
      description:
        'The destination screen to go to after Facebook Login or Signup (if the user did not have a user record in firestore)',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [{ field: 'enableApple', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Enable Apple',
      name: 'enableApple',
      editor: 'boolean',
      default: true,
      description: 'Show the login/signup by Apple Account',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Apple Post-Action Screen (existing user)',
      name: 'appleScreenExistingUser',
      description:
        'The destination screen to go to after Apple Login or Signup (if the user already had a user record in firestore)',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [{ field: 'enableApple', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Apple Post-Action Screen (new user)',
      name: 'appleScreenNewUser',
      description:
        'The destination screen to go to after Apple Login or Signup (if the user did not have a user record in firestore)',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [{ field: 'enableApple', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Enable Google',
      name: 'enableGoogle',
      editor: 'boolean',
      default: true,
      description: 'Show the login/signup by Google Account',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Enable Google on iOS',
      name: 'enableGoogleOniOS',
      editor: 'boolean',
      default: false,
      description:
        'Show the login/signup by Google Account Button when on an Apple iOS device',
      displayWhen: [{ field: 'enableGoogle', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Google Post-Action Screen (existing user)',
      name: 'googleScreenExistingUser',
      description:
        'The destination screen to go to after Google Login or Signup (if the user already had a user record in firestore)',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [{ field: 'enableGoogle', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Gogle Post-Action Screen (new user)',
      name: 'googleScreenNewUser',
      description:
        'The destination screen to go to after Google Login or Signup (if the user did not have a user record in firestore)',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [{ field: 'enableApple', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Use Google Light Button',
      name: 'useGoogleLightButton',
      editor: 'boolean',
      default: true,
      description: 'Show the light button as opped to the dark button',
      displayWhen: [{ field: 'enableGoogle', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Additional User Details Screen',
      name: 'additionalUserDetailsScreen',
      description:
        'The destination screen to go to after Apple/Google Login or Signup if we do not hold the first name, last name and email of the user.',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      name: 'emailButtonText',
      label: 'Email Button Text',
      description: '',
      editor: 'textbox',
      type: 'string',
      default: 'Email',
      displayWhen: [{ field: 'enableEmail', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      name: 'phoneButtonText',
      label: 'Phone Button Text',
      description: '',
      editor: 'textbox',
      type: 'string',
      default: 'Phone',
      displayWhen: [{ field: 'enablePhone', operator: '=', value: true }],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      name: 'userRole',
      label: 'User Role',
      description:
        'The role that will be used for any social signups that occur via this element. This value is secondary (does not override) a button whose "signupRole" has been set prior to landing on this screen. This is to enable a new user to choose their account type and signup with the correct role on this screen. If the app is not using multiple roles, then this role will be used as the role for the new user account.',
      editor: 'textbox',
      type: 'string',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Button Width',
      name: 'buttonWidth',
      editor: 'number',
      description: 'The width of the reset password button',
      default: 200,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Button Border Radius',
      name: 'buttonBorderRadius',
      editor: 'number',
      description: 'The border radius of the signup button',
      default: 4,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonFont',
      label: 'Button Font',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 14,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      name: 'buttonTextAlignment',
      label: 'Button Text Alignment',
      description: '',
      editor: 'alignment',
      type: 'string',
      default: 'justify-center',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonPadding',
      label: 'Button Padding',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '10 5 10 5',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonMargin',
      label: 'Button Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '5 0 5 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'buttonColor',
      label: 'Button Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'buttonBackgroundColor',
      label: 'Button Background Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#182fa4',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Show Change Role Link',
      name: 'showChangeRoleLink',
      editor: 'boolean',
      default: true,
      description: 'Show the change role link',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Change Role Screen',
      name: 'changeRoleScreen',
      description:
        'The destination screen where the user can re-select the role they want to signup under',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [
        { field: 'showChangeRoleLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Show Already Registered Link',
      name: 'showAlreadyRegisteredLink',
      editor: 'boolean',
      default: true,
      description: 'Show the already registered link',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Already Registered Link Text',
      name: 'alreadyRegisteredLinkText',
      editor: 'textbox',
      default: 'Already registered?',
      description: 'The link text for the already registered link',
      displayWhen: [
        { field: 'showAlreadyRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Already Registered Screen',
      name: 'alreadyRegisteredScreen',
      description: 'The destination screen for the already registered link',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [
        { field: 'showAlreadyRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Show Not Registered Link',
      name: 'showNotRegisteredLink',
      editor: 'boolean',
      default: true,
      description: 'Show the not registered link',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Not-Registered Link Text',
      name: 'notRegisteredLinkText',
      editor: 'textbox',
      default: 'Not registered?',
      description: 'The link text for the already not-registered link',
      displayWhen: [
        { field: 'showNotRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Not Registered Screen',
      name: 'notRegisteredScreen',
      description: 'The destination screen for the not registered link',
      editor: 'dropdown',
      default: ' ',
      options: [],
      function: {
        name: 'getAppScreens',
        params: ['app.id']
      },
      displayWhen: [
        { field: 'showNotRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      name: 'alreadyRegisteredLinkColor',
      label: 'Already Registered Link Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#ffffff',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },

    {
      name: 'alreadyRegisteredLinkFont',
      label: 'Already Registered Link Font',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 14,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      name: 'alreadyRegisteredLinkAlignment',
      label: 'Already Registered Link Alignment',
      description: '',
      editor: 'alignment',
      type: 'string',
      default: 'justify-center',
      displayWhen: [
        { field: 'showAlreadyRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'alreadyRegisteredLinkMargin',
      label: 'Already Registered Link Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '20 0 0 0',
      displayWhen: [
        { field: 'showAlreadyRegisteredLink', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Spinner Color',
      name: 'spinnerColor',
      editor: 'color',
      description:
        'The color of the activity indicator during scan processing.',
      default: '#182fa4',
      displayWhen: [
        {
          field: 'mode',
          operator: '=',
          value: 'scanner'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Spinner Size',
      name: 'spinnerSize',
      editor: 'dropdown',
      description: 'The size of the scanning spinner.',
      default: 'small',
      options: [
        { label: 'Small', value: 'small' },
        { label: 'Large', value: 'large' }
      ],
      displayWhen: [
        {
          field: 'mode',
          operator: '=',
          value: 'scanner'
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    }
  ]
};

export default SignupOrLoginMethodFields;
